var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.containerStyle)},[_c('v-quagga',{attrs:{"onDetected":_vm.onDetected,"readerSize":_vm.readerSize,"readerTypes":_vm.readerTypes,"facingMode":"environment"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }